import dateComparator from "./DateComparator";
import filterParams from "./DateFilter";

export const columnDefs = [
  {
    headerName: "Num",
    valueGetter: "node.rowIndex + 1",
    width: 90,
    suppressSizeToFit: false,
    checkboxSelection: true,
    minWidth: 90,
    maxWidth: 90,
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Block");
      // eslint-disable-next-line
      if (params?.data?.fk_id_patient == ID) {
        return "aggridGoBackStylesPriseEnCharge";
      } else {
        return "null";
      }
    },

    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_Session");
    //   if (params.data.fk_id_patient1 == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null"
    //   }
    // },
  },
  {
    // floatingFilter: true,
    headerName: "Date",
    field: "date_Lisible",
    // hide: true,
    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_PriseEnCharge");
    //   // eslint-disable-next-line
    //   if (params?.data?.idPriseEnCharge == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null";
    //   }
    // },
  },
  {
    floatingFilter: true,
    headerName: "Clinique",
    field: "NomClinique",
    hide: true,
    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_PriseEnCharge");
    //   // eslint-disable-next-line
    //   if (params?.data?.idPriseEnCharge == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null";
    //   }
    // },
  },
  // {
  //   headerName: "daysAgo",
  //   field: "daysAgo",
  //   hide: true,
  // },
  {
    floatingFilter: true,
    headerName: "Nom",
    field: "nom",
    cellClass: (params) => {
      let duration = params.data.daysAgo;
      let done = params.data.done;

      let result = "";
      if (duration > 120 && done === 0) {
        result = "classNegative";
      } else if (duration > 90 && done === 0) {
        result = "classWarning";
      }
      return result;
    },
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Prenom",
    field: "prenom",
    cellClass: (params) => {
      let duration = params.data.daysAgo;
      let done = params.data.done;

      let result = "";
      if (duration > 120 && done === 0) {
        result = "classNegative";
      } else if (duration > 90 && done === 0) {
        result = "classWarning";
      }
      return result;
    },
    // hide: true,
  },
  {
    headerName: "Mutuelle",
    field: "nom_mutuelle",
    // hide: true,
  },

  {
    headerName: "fk_id_clinique",
    field: "fk_id_clinique",
    hide: true,
  },
  {
    headerName: "Fk_idAuth",
    field: "fk_idAuth",
    hide: true,
  },
  {
    headerName: "Fk_id_patient",
    field: "fk_id_patient",
    hide: true,
  },
  {
    headerName: "Idbloc",
    field: "Idbloc",
    hide: true,
  },
  {
    headerName: "Fk_id_type_doperation",
    field: "fk_id_type_doperation",
    hide: true,
  },

  {
    headerName: "date",
    field: "date_bloc",
    filter: "date_bloc",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
  {
    headerName: "date_Lisible",
    field: "date_Lisible",
    hide: true,
  },
  {
    headerName: "Date_modification",
    field: "date_modification",
    hide: true,
  },
  {
    headerName: "Date_modification_Lisible",
    field: "date_modification_Lisible",
    hide: true,
  },
  {
    headerName: "statut",
    field: "done",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellRenderer: (params) => {
      let w;
      if (params.data.done === 1) {
        w = <div>Validée</div>;
      } else {
        w = <div>En cours</div>;
      }
      return w;
    },
    cellClass: (params) =>
      params.data.done === 1 ? "paidFooter" : "unpaidFooter",

    hide: true,
  },

  {
    floatingFilter: true,
    headerName: "Type D'Operation",
    field: "Nom_Type_D_Operationcol",
    hide: true,
  },
  {
    // floatingFilter: true,
    headerName: "Docteur",
    field: "user_name",
    hide: true,
  },

  {
    floatingFilter: true,
    headerName: "Mutualiste",
    field: "mutualiste",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellRenderer: (params) => {
      let w;
      if (params.data.mutualiste === 1) {
        w = <div>Oui</div>;
      } else {
        w = <div>Non</div>;
      }
      return w;
    },
    cellClass: (params) =>
      params.data.done === 1 ? "paidFooter" : "unpaidFooter",

    hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Total",
    field: "montantNet",
    cellClass: "totalFacturation"
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Total",
    field: "montant",
    cellClass: "totalFacturation",
    hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Payment",
    field: "payment",
    cellClass: (params) => {
      const {
        montant,
        payment,
        remise,
        suplement
      } = params.data
      let result = "totalPayement"
      let montantDefinitif = montant + suplement - remise

      if (montantDefinitif > payment && payment !== 0) {
        result = "classWarning";
      } else if (montantDefinitif < payment) {
        result = "classNegative";
      } else if (payment === 0) {
        result = "totalPayement"
      }

      return result

    }
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Reste",
    field: "reste",
    cellClass: (params) => {
      const {
        reste,
      } = params.data
      let result = "totalReste"

      if (reste > 0) {
        result = "classNegative";
      } else if (reste < 0) {
        result = "classWarning";
      }

      return result

    }
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Commentaire",
    field: "commentaire",
    // hide: true,
  },
  {
    // floatingFilter: true,
    headerName: "Suplement",
    field: "suplement",
    hide: true,
  },
  {
    // floatingFilter: true,
    headerName: "Remise",
    field: "remise",
    hide: true,
  },
];
export const columnDefs2 = [
  {
    headerName: "date_consultation_For_Server",
    field: "date_consultation_For_Server",
    hide: true,
  },
  {
    headerName: "Total du :",
    field: "total",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "date consultation",
    field: "date_consultation",
  },
  {
    headerName: "gain latent",
    field: "gain_latent",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "montant total",
    field: "sum_act",
    cellClass: (params) => (params.value > 0 ? "gain_latent" : null),
  },
  {
    headerName: "Payment_titre",
    field: "payment_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "payment",
    field: "payment",
    cellClass: (params) =>
      params.value === 0
        ? "unpaidFooter"
        : params.value > 0
          ? "paidFooter"
          : null,
  },
  {
    headerName: "reste_a_payer_titre",
    field: "reste_a_payer_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "reste a payer",
    field: "rest",
    cellStyle: { textAlign: "center" },
    // cellClass: (params) =>
    //   params.value === 0
    //     ? "paidFooter"
    //     : params.value > 0
    //     ? "unpaidFooter"
    //     : params.value < 0
    //     ? "overPaidFooter"
    //     : null,
  },
  // {
  //   headerName: "Numero",
  //   valueGetter: "node.rowIndex + 1",
  //   width: 90,
  //   suppressSizeToFit: false,
  //   checkboxSelection: true,
  //   minWidth: 90,
  //   maxWidth: 90,
  // },
];

// export const defaultColDef = {
//   sortable: true,
//   flex: 1,
//   // filter stuff
//   filter: true,
//   floatingFilter: true,
//   suppressMenu: true,
//   // end of filter stuff
//   minWidth: 100,
//   resizable: true,
//   filterParams: {
//     newRowsAction: "keep",
//   },
// };

export const topOptions = {
  alignedGrids: [],
  defaultColDef: {
    suppressMovable: true,
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    cellStyle: { textAlign: "center" },
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
  suppressHorizontalScroll: true,
};

export const bottomOptions = {
  alignedGrids: [],
  defaultColDef: {
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    floatingFilter: true,
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
};
